import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import { browserHistory, Router } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'

import routes from './routes'
import store from './store'

import 'semantic-ui-css/semantic.min.css'

const history = syncHistoryWithStore(browserHistory, store)

ReactDOM.render(
  <Provider store={store}>
    <Router history={history} routes={routes} />
  </Provider>,
  document.getElementById('root'),
)
